import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FestivalLeaveProvider, useLeave } from './getfestivalLeave';
import messages from "../../../../Utils/lang";
import { postToAPI,formatISODateWithTimezone } from '../../../../Utils/utils';

export default function NewFestivalLeave({ onSuccess }) {
    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    const initialInputData = {
        holiday_name: '',
        start_date: '',
        end_date: '',
        description: '',
        isdeleted: 0,
        created_date: formatISODateWithTimezone(new Date()),
        last_modified_date: formatISODateWithTimezone(new Date()),
        created_user_id: 1,
        last_modified_user_id: 1,
        reserve_varchar: 'NA',
        reserve_float: 0.0,
        reserve_int: 0,
        reserve_double1: 0.0,
        reserve_date1: new Date().toISOString().split('T')[0],
    };

    const { getFestivalLeave, fetchFestivalLeave } = useLeave();
    const [leaveInputData, setLeaveInputData] = useState(initialInputData);

    const handleSubmit = async () => {
        if (!leaveInputData.holiday_name.trim()) {
            toast.error(messages.festivalLeave.required_holiday_name);
            return;
        }
        if (!leaveInputData.start_date || !leaveInputData.end_date) {
            toast.error(messages.festivalLeave.required_date);
            return;
        }
    
        if (leaveInputData.start_date > leaveInputData.end_date) {
            toast.error(messages.festivalLeave.invalid_date_range);
            return;
        }
        if (!leaveInputData.description.trim()) {
            toast.error(messages.festivalLeave.required_description);
            return;
        }
    
        const isExists = getFestivalLeave.find(
            (leave) => leave.holiday_name === leaveInputData.holiday_name
        );
        if (isExists) {
            toast.error(messages.festivalLeave.already_exist);
            return;
        }
    
        try {
            const response = await postToAPI('FtsFestivalLeave/', leaveInputData);
    
            if (response.status) {
                toast.success(messages.festivalLeave.added_successfully);
                fetchFestivalLeave();
                if (onSuccess && response.data.id) {
                    onSuccess(response.data.id);
                }
                setLeaveInputData(initialInputData);
            } else {
                // Handle backend validation errors (if any)
                if (response.errors) {
                    if (response.errors.start_date) {
                        toast.error("Start Date has wrong format. Use YYYY-MM-DD.");
                    }
                    if (response.errors.end_date) {
                        toast.error("End Date has wrong format. Use YYYY-MM-DD.");
                    }
                } else {
                    toast.error(messages.festivalLeave.failed_to_add);
                }
            }
        } catch (error) {
            toast.error("Invalid date format");
            
        }
    };
    

    const handleCancel = () => {
        setLeaveInputData(initialInputData);
    };

    const isFormValid = () => {
        return (
            leaveInputData.holiday_name.trim() &&
            leaveInputData.start_date &&
            leaveInputData.end_date &&
            leaveInputData.description.trim()
        );
    };

    return (
        <>
            <Card className="right-content-details">
                <Card.Body>
                    <Card.Title>Add Festival</Card.Title>
                    <Form>
                        <Row>
                            <Col xl={6}>
                                <div className="mb-3 custom-form-input">
                                    <Form.Label>
                                        Festival Name <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Festival Name..."
                                        name="holiday_name"
                                        value={leaveInputData.holiday_name}
                                        onChange={(e) =>
                                            setLeaveInputData({
                                                ...leaveInputData,
                                                holiday_name: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3 custom-form-input">
                                    <Form.Label>
                                        Start Date <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="start_date"
                                        value={leaveInputData.start_date}
                                        onChange={(e) =>
                                            setLeaveInputData({
                                                ...leaveInputData,
                                                start_date: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3 custom-form-input">
                                    <Form.Label>
                                        End Date <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="end_date"
                                        value={leaveInputData.end_date}
                                        onChange={(e) =>
                                            setLeaveInputData({
                                                ...leaveInputData,
                                                end_date: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </Col>
                            <Col xl={6}>
                            <div className="mb-3 custom-form-input">
                                <Form.Label>
                                    Description <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows="4"
                                    placeholder="Enter description..."
                                    name="description"
                                    value={leaveInputData.description}
                                    onChange={(e) =>
                                        setLeaveInputData({
                                            ...leaveInputData,
                                            description: e.target.value,
                                        })
                                    }
                                    style={{ whiteSpace: "pre-wrap", overflow: "hidden", resize: "none" }}
                                />
                            </div>

                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
                <div className="custom-card-footer">
                    <div className="text-end btn-list">
                        <Button
                            variant="primary"
                            onClick={handleSubmit}
                            disabled={!isFormValid()}
                        >
                            Add
                        </Button>{' '}
                        <Button variant="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>{' '}
                    </div>
                </div>
            </Card>
        </>
    );
}
